import React from 'react';
import { Box, Typography } from '@mui/material';
import T from '../theme';
import { DataTable, InsightList, WhyThisMatters, getPlatformIcon } from '../components/Shared.jsx';

export function SocialScan({ data }) {
  const { detectedAccounts: rawAccounts = [], contactPathsFound = [], accountHealth = [], insights = [] } = data;
  // Filter "Website" from detected accounts — not a social platform
  const detectedAccounts = rawAccounts.filter((a) => !/^website$/i.test(a.platform));
  // Build a lookup so we can show status/engagement inline on each account card
  const healthByPlatform = {};
  accountHealth.forEach((h) => { healthByPlatform[h.platform?.toLowerCase()] = h; });

  return (
    <Box>
      {detectedAccounts.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.textSecondary, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>Detected Accounts</Typography>
          {detectedAccounts.map((acc, i) => (
            <Box key={i} sx={{ mb: 1, p: 1.75, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 0.5, flexWrap: 'wrap' }}>
                <Box sx={{ color: T.accent, display: 'flex', alignItems: 'center' }}>{getPlatformIcon(acc.platform)}</Box>
                <Typography sx={{ fontWeight: 700, fontSize: 13, color: T.text }}>{acc.platform}</Typography>
                {acc.profileUrl && acc.profileUrl !== 'unknown'
                  ? <Typography component="a" href={acc.profileUrl} target="_blank" rel="noreferrer" sx={{ fontSize: 13, color: T.accent, textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>@{acc.handle}</Typography>
                  : <Typography sx={{ fontSize: 13, color: T.accent }}>@{acc.handle}</Typography>
                }
                {acc.verified && (
                  <Box sx={{ px: 1, py: 0.25, background: 'rgba(34,197,94,0.15)', color: T.success, borderRadius: 4, fontSize: 11 }}>✓ Verified</Box>
                )}
                {/* Fix 33: Status + engagement badges hidden — AI returns unreliable status data. TODO 1.5: re-enable with real activity data */}
                {/* {(() => { const h = healthByPlatform[acc.platform?.toLowerCase()]; return h ? <>
                  <Box sx={{ px: 1, py: 0.25, background: h.status === 'active' ? 'rgba(34,197,94,0.15)' : h.status === 'dormant' ? 'rgba(234,179,8,0.15)' : 'rgba(239,68,68,0.15)', color: h.status === 'active' ? T.success : h.status === 'dormant' ? T.warning : T.error, borderRadius: 4, fontSize: 11, fontWeight: 600, textTransform: 'uppercase' }}>{h.status}</Box>
                  {h.engagement && <Box sx={{ px: 1, py: 0.25, background: T.surface, border: `1px solid ${T.border}`, borderRadius: 4, fontSize: 11, color: T.textSecondary }}>{h.engagement}</Box>}
                </> : null; })()} */}
              </Box>
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                {acc.followers != null && acc.followers > 0 && <Typography sx={{ fontSize: 11, color: T.textSecondary }}>{acc.followers.toLocaleString()} followers</Typography>}
                {acc.postingCadence && acc.postingCadence !== 'unknown' && <Typography sx={{ fontSize: 11, color: T.textSecondary }}>{acc.postingCadence}</Typography>}
                {acc.lastPostDaysAgo != null && acc.lastPostDaysAgo >= 0 && <Typography sx={{ fontSize: 11, color: T.textSecondary }}>Last: {acc.lastPostDaysAgo}d ago</Typography>}
              </Box>
            </Box>
          ))}
        </Box>
      )}

      {/* Account Health data now shown inline on each account card above */}

      {contactPathsFound.length > 0 && (
        <Box sx={{ mb: 3 }}>
          <Typography sx={{ fontSize: 12, fontWeight: 700, color: T.accent, textTransform: 'uppercase', letterSpacing: 0.5, mb: 1.5 }}>Contact Paths</Typography>
          <DataTable
            columns={['Type', 'Value', 'Platform', 'Location']}
            rows={contactPathsFound.map((cp) => [cp.type, cp.value, cp.platform, cp.location])}
          />
        </Box>
      )}

      <InsightList insights={insights} />
      <WhyThisMatters text="Social scan reveals where the audience lives and the best outreach channels." citations={data.expertCitations} />
    </Box>
  );
}
